import React from "react";
import { FilterPriceMax } from "components/information-lister-pages/HomeContent/elements/FilterPriceMax";
import { FilterYearMin } from "components/information-lister-pages/HomeContent/elements/FilterYearMin";
import { Number } from "components/Number";
import { Button } from "components/shared/buttons/Button";
import { Loading } from "components/shared/Loading";
import { useForm } from "lib/form";
import { useCounts, useSearchFilters } from "services/search";
import styled from "styled-components";
import ArrowRight from "svg/arrow-right.svg";
import { device, mq, useMediaContext } from "lib/media-query";
import { BrandFilter } from "components/filters/BrandFilter";
import { ModelFilter } from "components/filters/ModelFilter";
import { LoaderWrapper } from "./LoaderWrapper";

const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 0 8px;

    ${mq.from(device.TABLET)`
    grid-template-columns: 1fr 1fr 2fr 270px;
    gap: 0;
  `}
`;

const Item = styled.div`
    min-width: 0;
`;

const ItemWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
`;

const StyledButton = styled(Button)`
    margin: 0;
    height: 44px;

    ${mq.from(device.TABLET)`
    margin: 0 0 0 16px;
  `}
`;

export const BasicSearchFields = () => {
    const [, setSearchFilters] = useSearchFilters();
    const [counts] = useCounts(true);
    const media = useMediaContext();
    const isMobile = media.isMobile || media.isMobilePlus || media.isTablet;

    const [submit, isSubmitting] = useForm({
        onChange: (values) => {
            setSearchFilters((searchFilters) => ({ ...searchFilters, ...values }));
        }
    });

    return (
        <Container isMobile={isMobile}>
            <Item data-testid="brand-input">
                <BrandFilter position={isMobile ? "default" : "left"} />
            </Item>
            <Item data-testid="model-input">
                <ModelFilter position={isMobile ? "default" : "center"} />
            </Item>
            <ItemWrapper>
                <FilterPriceMax isMobile={isMobile} />
                <FilterYearMin />
            </ItemWrapper>
            <StyledButton
                isMobile={isMobile}
                size="normal"
                alignIcon="right"
                disabled={isSubmitting}
                data-testid="bekijk-resultaten"
                onClick={submit}
            >
                Bekijk {counts?.total ? <Number value={counts.total} /> : "de"} resultaten
                {isSubmitting ? (
                    <LoaderWrapper>
                        <Loading />
                    </LoaderWrapper>
                ) : (
                    <ArrowRight />
                )}
            </StyledButton>
        </Container>
    );
};
